import { render, staticRenderFns } from "./FluxPagination.vue?vue&type=template&id=08a63c70&"
import script from "./FluxPagination.vue?vue&type=script&lang=js&"
export * from "./FluxPagination.vue?vue&type=script&lang=js&"
import style0 from "./FluxPagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports